const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoFactorAuthenticationRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-214--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-214--inject-1",
    cx: 250,
    cy: 431.27,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,341.53H45.31a5.72,5.72,0,0,1-5.71-5.71V64.39a5.72,5.72,0,0,1,5.71-5.66H238.4a5.71,5.71,0,0,1,5.7,5.71h0V335.82A5.71,5.71,0,0,1,238.4,341.53ZM45.31,58.93a5.47,5.47,0,0,0-5.46,5.46V335.82a5.47,5.47,0,0,0,5.46,5.46H238.4a5.46,5.46,0,0,0,5.45-5.46V64.39a5.46,5.46,0,0,0-5.45-5.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,341.53H261.6a5.71,5.71,0,0,1-5.7-5.71V64.39a5.71,5.71,0,0,1,5.7-5.66H454.7a5.71,5.71,0,0,1,5.7,5.66V335.82A5.71,5.71,0,0,1,454.7,341.53ZM261.6,58.93a5.46,5.46,0,0,0-5.45,5.46V335.82a5.46,5.46,0,0,0,5.45,5.46H454.7a5.48,5.48,0,0,0,5.47-5.46V64.39a5.48,5.48,0,0,0-5.47-5.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.73,
    y: 392.21,
    width: 41.21,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.61,
    y: 390.21,
    width: 41.33,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.72,
    y: 390.21,
    width: 10,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.52,
    y: 398.75,
    width: 46.25,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.14,
    y: 392.08,
    width: 21.6,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.64,
    y: 392.08,
    width: 27.93,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.83,
    y: 396.31,
    width: 62.44,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.83,79.48l-2.49,34.28a4.94,4.94,0,0,1-1.39,3.09,5,5,0,0,1-3.61,1.58H299.85a4.32,4.32,0,0,1-4.35-4.67L298,79.48a5.08,5.08,0,0,1,5-4.67h27.49A4.29,4.29,0,0,1,334.83,79.48Z",
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.39,
    cy: 95,
    rx: 9.22,
    ry: 7.47,
    transform: "translate(157.81 384.24) rotate(-78.18)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.38,116.07H301.22c-1.6,0-2.7-.77-2.74-1.84-.06-1.56,8.1-8.31,15.84-7.72h.18a21.23,21.23,0,0,1,12.95,5C331.19,114.45,327.66,116.07,326.38,116.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,117.18a10.6,10.6,0,0,1-10.51-9.59,9,9,0,0,1,8.91-9.84,10.6,10.6,0,0,1,10.51,9.59A9,9,0,0,1,193,117.18Zm-1.17-14.27a4.2,4.2,0,0,0-4.18,4.61,5,5,0,0,0,4.93,4.5,4.2,4.2,0,0,0,4.17-4.61A5,5,0,0,0,191.85,102.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.5 102.16 189.82 102.21 187.86 78.49 191.55 78.45 193.5 102.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.04 79.51 188.12 79.6 187.82 75.91 194.74 75.82 195.04 79.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.44 84.25 188.93 84.33 188.63 80.64 195.13 80.56 195.44 84.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196 90.93 190.32 91 190.01 87.32 195.69 87.25 196 90.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.31,318.77a8.65,8.65,0,0,0,.11.89,9,9,0,0,0,2.73,5,8.85,8.85,0,0,0,6,2.43h84.49a7.6,7.6,0,0,0,7.72-7.4,9,9,0,0,0-8.88-9.17H87A7.62,7.62,0,0,0,79.31,318.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.39,319.66a5.29,5.29,0,0,1-.08.8,9,9,0,0,0-8.84-8l-89.85.14a7.7,7.7,0,0,1,5.4-2.14h84.49a8.82,8.82,0,0,1,8.88,9.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.93,314.48l.28,4,3.79-1.41.86,2L167,320.39l2.7,3.39L168,325.06l-2.63-3.52-2.1,3.52-1.87-1.28,2.19-3.39-4-1.27.57-2,4,1.36-.28-4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.82,314.48l.29,4,3.78-1.41.86,2-3.87,1.27,2.71,3.39-1.75,1.28-2.63-3.52-2.1,3.52-1.87-1.28,2.19-3.39-4-1.27.58-2,4,1.36-.28-4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72,314.48l.28,4,3.79-1.41.86,2-3.87,1.27,2.7,3.39-1.75,1.28-2.63-3.52-2.1,3.52-1.87-1.28,2.19-3.39-4-1.27.58-2,4,1.36-.28-4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,314.48l.28,4,3.79-1.41.86,2-3.87,1.27,2.7,3.39-1.74,1.28L96,321.54l-2.11,3.52L92,323.78l2.2-3.39-4-1.27.58-2,4,1.36-.28-4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.74 307.57 148.8 307.57 148.81 306.57 152.75 306.57 152.74 307.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.67 307.57 156.82 307.57 156.84 306.57 169.69 306.57 169.67 307.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.38,302.53l15.94,24.53,52.56-52.56a.52.52,0,0,0-.69-.78L287.1,313l-9.46-15.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.86 127.95 222.12 269.11 234.81 269.11 272.13 127.95 259.86 127.95",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.45 127.95 241.71 269.11 266.89 269.11 304.21 127.95 279.45 127.95",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.31,255.31l8-113.3a6.24,6.24,0,0,0-6.33-6.77l-197.74.17a7.42,7.42,0,0,0-7.29,6.78L204,255.5a6.25,6.25,0,0,0,6.34,6.77L408,262.1A7.41,7.41,0,0,0,415.31,255.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.77,252.84l8-113.3a6.23,6.23,0,0,0-6.33-6.77l-197.74.17a7.4,7.4,0,0,0-7.28,6.78l-8,113.31a6.24,6.24,0,0,0,6.33,6.77l197.73-.17A7.41,7.41,0,0,0,412.77,252.84Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.53,254.52a2.2,2.2,0,0,1-1.49.58l-197.74.17a2.35,2.35,0,0,1-2.32-2.48l8-113.3a2.12,2.12,0,0,1,.68-1.44,2.15,2.15,0,0,1,1.49-.58l197.74-.17a2.35,2.35,0,0,1,2.32,2.48l-8,113.3A2.17,2.17,0,0,1,407.53,254.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.76,192.23H272.35a2.53,2.53,0,0,0-2.47,2.23l-1.07,10.15a2,2,0,0,0,2,2.24h69.41a2.55,2.55,0,0,0,2.48-2.24l1.06-10.15A2,2,0,0,0,341.76,192.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61,233.68H269.78a2.55,2.55,0,0,0-2.48,2.24l-1.06,10.15a2,2,0,0,0,2,2.23h10.83a2.55,2.55,0,0,0,2.48-2.23l1.06-10.15A2,2,0,0,0,280.61,233.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.31,233.68H288.48a2.55,2.55,0,0,0-2.48,2.24l-1.06,10.15a2,2,0,0,0,2,2.23h10.83a2.55,2.55,0,0,0,2.48-2.23l1.06-10.15A2,2,0,0,0,299.31,233.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,233.68H307.18a2.55,2.55,0,0,0-2.48,2.24l-1.06,10.15a2,2,0,0,0,2,2.23h10.83a2.55,2.55,0,0,0,2.48-2.23L320,235.92A2,2,0,0,0,318,233.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.71,233.68H325.88a2.55,2.55,0,0,0-2.48,2.24l-1.06,10.15a2,2,0,0,0,2,2.23h10.83a2.55,2.55,0,0,0,2.48-2.23l1.06-10.15A2,2,0,0,0,336.71,233.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.47,227.27H281.06a3.86,3.86,0,0,1-3.92-4.35l.52-5a4.85,4.85,0,0,1,4.72-4.25h43.41a3.87,3.87,0,0,1,3.92,4.36l-.52,5A4.85,4.85,0,0,1,324.47,227.27Zm-42.09-12.59a3.85,3.85,0,0,0-3.73,3.36l-.52,5a2.87,2.87,0,0,0,2.93,3.25h43.41a3.84,3.84,0,0,0,3.73-3.35l.52-5a2.87,2.87,0,0,0-2.93-3.25Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,171.09H274.85a2.55,2.55,0,0,0-2.47,2.24l-1.07,10.15a2,2,0,0,0,2,2.23h69.4a2.55,2.55,0,0,0,2.48-2.23l1.06-10.15A2,2,0,0,0,344.26,171.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.79,199.54a2.19,2.19,0,0,0-2.22-2.48,2.84,2.84,0,0,0-2.75,2.48,2.2,2.2,0,0,0,2.23,2.47A2.82,2.82,0,0,0,280.79,199.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.43,199.54a2.2,2.2,0,0,0-2.23-2.48,2.82,2.82,0,0,0-2.74,2.48,2.19,2.19,0,0,0,2.22,2.47A2.83,2.83,0,0,0,288.43,199.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.06,199.54a2.2,2.2,0,0,0-2.23-2.48,2.82,2.82,0,0,0-2.74,2.48,2.2,2.2,0,0,0,2.23,2.47A2.82,2.82,0,0,0,296.06,199.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.69,199.54a2.19,2.19,0,0,0-2.22-2.48,2.82,2.82,0,0,0-2.74,2.48A2.18,2.18,0,0,0,301,202,2.82,2.82,0,0,0,303.69,199.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.48,199.54a2.2,2.2,0,0,0-2.23-2.48,2.82,2.82,0,0,0-2.74,2.48,2.19,2.19,0,0,0,2.22,2.47A2.83,2.83,0,0,0,311.48,199.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.29,178.4a2.18,2.18,0,0,0-2.22-2.47,2.82,2.82,0,0,0-2.74,2.47,2.18,2.18,0,0,0,2.22,2.47A2.81,2.81,0,0,0,283.29,178.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.93,178.4a2.2,2.2,0,0,0-2.23-2.47A2.82,2.82,0,0,0,286,178.4a2.19,2.19,0,0,0,2.22,2.47A2.82,2.82,0,0,0,290.93,178.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.56,178.4a2.19,2.19,0,0,0-2.22-2.47,2.83,2.83,0,0,0-2.75,2.47,2.19,2.19,0,0,0,2.23,2.47A2.81,2.81,0,0,0,298.56,178.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.19,178.4a2.18,2.18,0,0,0-2.22-2.47,2.82,2.82,0,0,0-2.74,2.47,2.18,2.18,0,0,0,2.22,2.47A2.81,2.81,0,0,0,306.19,178.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.83,178.4a2.2,2.2,0,0,0-2.23-2.47,2.82,2.82,0,0,0-2.74,2.47,2.19,2.19,0,0,0,2.23,2.47A2.81,2.81,0,0,0,313.83,178.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.46,178.4a2.19,2.19,0,0,0-2.22-2.47,2.83,2.83,0,0,0-2.75,2.47,2.19,2.19,0,0,0,2.23,2.47A2.81,2.81,0,0,0,321.46,178.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,148.71l-.54,5.13a1,1,0,0,1-.93.83.73.73,0,0,1-.75-.83l.54-5.13a2.67,2.67,0,0,0-2.7-3h-1.85a3.44,3.44,0,0,0-3.33,3l-.47,4.76h-1.68l.47-4.76a5.33,5.33,0,0,1,5.19-4.67h1.84A4.14,4.14,0,0,1,315,148.71Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,153.65l-1.05,10a1.31,1.31,0,0,1-1.27,1.14h-10a1,1,0,0,1-1-1.14l1.05-10a1.3,1.3,0,0,1,.64-1,1.24,1.24,0,0,1,.63-.17h10a1.09,1.09,0,0,1,.58.16A1,1,0,0,1,315,153.65Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.87,132.75a.5.5,0,1,1,0-1l24.44-.14h0a.5.5,0,1,1,0,1l-24.43.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,132.58a.5.5,0,0,1,0-1l8.64,0h0a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5l-8.64,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.1,137.44h28L234.63,255.27H212.06a4.32,4.32,0,0,1-4.1-5.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.5 137.44 287.37 137.44 258.93 255.27 247.06 255.27 275.5 137.44",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.65,100.66h5.68A9.52,9.52,0,0,0,82.71,111l12.05,172.3a11.26,11.26,0,0,0,11.06,10.34h-5.67a11.27,11.27,0,0,1-11.07-10.34L77,111A9.52,9.52,0,0,1,86.65,100.66Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.65,100.66h5.68A9.52,9.52,0,0,0,82.71,111l12.05,172.3a11.26,11.26,0,0,0,11.06,10.34h-5.67c-5.71,0-11.47-4.63-11.87-10.34L76.23,111C75.83,105.29,80.94,100.66,86.65,100.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.84,293.65h69.5A9.52,9.52,0,0,0,181,283.31L168.91,111a11.26,11.26,0,0,0-11.07-10.35H88.35A9.52,9.52,0,0,0,78.73,111l12,172.3A11.27,11.27,0,0,0,101.84,293.65Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.66,104a7.84,7.84,0,0,1,7.69,7.2l12.05,172.3a6.27,6.27,0,0,1-6.37,6.85H101.54a7.85,7.85,0,0,1-7.7-7.2l-12-172.3A6.27,6.27,0,0,1,88.16,104Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138,290.33H110.31L133.17,104h22.31a7,7,0,0,1,5.14,2.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.34 290.33 99.1 290.33 121.96 103.98 128.2 103.98 105.34 290.33",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.52,185.9H103.18a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h50.34a.51.51,0,0,1,.5.5A.5.5,0,0,1,153.52,185.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.1,193.35H109.67a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H149.1a.5.5,0,0,1,.5.5A.5.5,0,0,1,149.1,193.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.68,151.08l.07,2h-1.29l-.07-2-2.29-3.59h1.37l1.58,2.48,1.4-2.48h1.27Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.77,150.26a2.77,2.77,0,0,1,3-2.88,3,3,0,0,1,3.15,2.88,2.77,2.77,0,0,1-3,2.89A3,3,0,0,1,106.77,150.26Zm4.8,0a1.77,1.77,0,0,0-1.81-1.78,1.62,1.62,0,0,0-1.68,1.78,1.77,1.77,0,0,0,1.81,1.79A1.64,1.64,0,0,0,111.57,150.26Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.81,150.6l-.1-3.13H115l.1,3.08c0,1.06.52,1.5,1.3,1.5s1.22-.44,1.19-1.5l-.11-3.08h1.27l.11,3.13a2.22,2.22,0,0,1-2.43,2.55A2.41,2.41,0,0,1,113.81,150.6Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.78,153.06l-1.13-1.56h-1.19l.06,1.56h-1.29l-.2-5.59h2.42c1.49,0,2.45.78,2.49,2a1.73,1.73,0,0,1-1.09,1.76l1.32,1.8Zm-1.37-4.53h-1l.07,1.94h1c.79,0,1.17-.36,1.15-1S123.2,148.53,122.41,148.53Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.9,150.26a2.74,2.74,0,0,1,2.92-2.88,3,3,0,0,1,2.33,1l-.8.76a1.87,1.87,0,0,0-1.43-.65,1.64,1.64,0,0,0-1.72,1.78,1.78,1.78,0,0,0,1.85,1.79,1.7,1.7,0,0,0,1.38-.66l.85.76a2.74,2.74,0,0,1-2.26,1A3,3,0,0,1,127.9,150.26Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62,150.26a2.77,2.77,0,0,1,2.95-2.88,3,3,0,0,1,3.15,2.88,2.77,2.77,0,0,1-2.95,2.89A3,3,0,0,1,133.62,150.26Zm4.79,0a1.76,1.76,0,0,0-1.8-1.78,1.62,1.62,0,0,0-1.68,1.78,1.76,1.76,0,0,0,1.8,1.79A1.63,1.63,0,0,0,138.41,150.26Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,147.47h2.53a2.89,2.89,0,0,1,3.17,2.79,2.67,2.67,0,0,1-3,2.8h-2.54Zm2.63,4.53a1.61,1.61,0,0,0,1.77-1.74,1.74,1.74,0,0,0-1.89-1.73h-1.18l.12,3.47Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.66,152l0,1h-4.32l-.2-5.59h4.22l0,1H148.5l0,1.21h2.59l0,1h-2.59l0,1.29Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.38,173.81l0,2.24H103.89l0-1.77,5.58-5.39c1.36-1.33,1.59-2.16,1.58-3,0-1.3-.94-2.06-2.69-2.06a4,4,0,0,0-3.32,1.49l-1.88-1.43a6.46,6.46,0,0,1,5.38-2.36c3.1,0,5.13,1.57,5.17,4.1,0,1.38-.34,2.65-2.28,4.51l-3.75,3.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,171.77c0,2.4-1.74,4.48-5.57,4.48a9.13,9.13,0,0,1-5.4-1.65l1.11-2.06a6.77,6.77,0,0,0,4.21,1.41c1.89,0,3-.84,3-2.16s-1-2.13-3.14-2.13h-1.3l0-1.81L122,164h-6.49l0-2.22h9.74l0,1.78-3.4,4.12C124.58,168,126,169.62,126,171.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.34,172c0,2.65-2.23,4.3-5.78,4.3s-5.85-1.65-5.89-4.3a3.51,3.51,0,0,1,2.22-3.41,3.34,3.34,0,0,1-1.83-3c0-2.45,2.08-4,5.24-4s5.37,1.53,5.41,4a3.17,3.17,0,0,1-1.76,3A3.69,3.69,0,0,1,139.34,172Zm-2.68-.08c0-1.41-1.26-2.29-3.22-2.29s-3.13.88-3.1,2.29,1.22,2.3,3.18,2.3S136.69,173.32,136.66,171.87Zm-6-6.2c0,1.22,1,2,2.73,2s2.72-.78,2.69-2-1.13-2-2.77-2S130.66,164.38,130.68,165.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,172c0,2.65-2.23,4.3-5.78,4.3S141,174.6,141,172a3.52,3.52,0,0,1,2.22-3.41,3.31,3.31,0,0,1-1.82-3c-.05-2.45,2.07-4,5.23-4s5.37,1.53,5.41,4a3.17,3.17,0,0,1-1.76,3A3.69,3.69,0,0,1,152.64,172Zm-2.68-.08c0-1.41-1.26-2.29-3.22-2.29s-3.13.88-3.1,2.29,1.22,2.3,3.18,2.3S150,173.32,150,171.87Zm-6-6.2c0,1.22,1.05,2,2.73,2s2.72-.78,2.7-2-1.14-2-2.77-2S144,164.38,144,165.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.49,150.31a.5.5,0,0,1-.5-.47l-1.77-24.17a.5.5,0,0,1,.46-.53.51.51,0,0,1,.54.46L79,149.77a.5.5,0,0,1-.46.54Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.38,121.5a.5.5,0,0,1-.5-.46l-.47-6.38a.5.5,0,0,1,1-.07l.47,6.38a.5.5,0,0,1-.46.53Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.37,91.09a.5.5,0,0,1-.5-.5V75.88a.5.5,0,0,1,1,0V90.59A.5.5,0,0,1,123.37,91.09Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.72,94.21a.5.5,0,0,1-.43-.25l-7.36-12.74a.5.5,0,0,1,.87-.5l7.35,12.74a.49.49,0,0,1-.18.68A.55.55,0,0,1,111.72,94.21Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,94.21a.54.54,0,0,1-.25-.06.51.51,0,0,1-.18-.69l7.35-12.74a.5.5,0,0,1,.87.5L135.45,94A.5.5,0,0,1,135,94.21Z",
    style: {
      fill: "#FCB040"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.33,413.87a212.77,212.77,0,0,1,6.08-62.23l1,.24a212.13,212.13,0,0,0-6.06,61.94Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.22,350.9c0,1.86,1.72,8.47,3.59,8.42s3.22-6.72,3.17-8.59a3.38,3.38,0,1,0-6.76.17Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.49,371.89c0-1.87-1.72-8.47-3.58-8.43s-3.22,6.72-3.18,8.59a3.38,3.38,0,1,0,6.76-.16Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.36,365c1.87,0,8.47-1.72,8.42-3.59s-6.71-3.22-8.58-3.17a3.38,3.38,0,1,0,.16,6.76Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.35,357.76c-1.86,0-8.47,1.72-8.42,3.58s6.72,3.22,8.59,3.18a3.38,3.38,0,0,0-.17-6.76Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.86,356.54c1.36,1.29,7.21,4.78,8.5,3.42s-2.48-7-3.83-8.31a3.38,3.38,0,1,0-4.67,4.89Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.85,366.24c-1.35-1.29-7.2-4.77-8.49-3.42s2.47,7,3.82,8.32a3.38,3.38,0,1,0,4.67-4.9Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,371.39c1.29-1.36,4.77-7.21,3.42-8.5s-7,2.48-8.32,3.83a3.38,3.38,0,0,0,4.9,4.67Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,351.4c-1.29,1.35-4.78,7.2-3.42,8.49s7-2.47,8.31-3.82a3.38,3.38,0,1,0-4.89-4.67Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.85,361.49a4,4,0,1,0,3.91-4.1A4,4,0,0,0,308.85,361.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.28,391.25s.69-10.21,6.3-11.82,7.66-3.81,7.66-3.81S321.67,391.45,308.28,391.25Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.28,391.25s.69-10.21,6.3-11.82,7.66-3.81,7.66-3.81S321.67,391.45,308.28,391.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.54,399.07s-.69-10.21-6.3-11.83-7.66-3.8-7.66-3.8S294.15,399.27,307.54,399.07Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.54,399.07s-.69-10.21-6.3-11.83-7.66-3.8-7.66-3.8S294.15,399.27,307.54,399.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.7,420.34c0,8-9.49,14.42-21.19,14.42s-21.19-6.45-21.19-14.42c0-4,2.43-7.68,6.36-10.29a24.1,24.1,0,0,1,8.12-3.38h13.42a24.17,24.17,0,0,1,8.31,3.51C326.35,412.79,328.7,416.37,328.7,420.34Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.22,406.67a24.17,24.17,0,0,1,8.31,3.51c3.82,2.61,6.17,6.19,6.17,10.16,0,8-9.49,14.42-21.19,14.42s-21.19-6.45-21.19-14.42c0-4,2.43-7.68,6.36-10.29a24.1,24.1,0,0,1,8.12-3.38Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.07,
    y: 407.97,
    width: 1,
    height: 7.13,
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.46 406.45 322.34 409.95 322.32 409.99 292.69 409.99 292.63 409.8 291.56 406.45 323.46 406.45",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.2,423.24a23,23,0,0,1-8.14,7c-5.09,2.7-26.5,3.39-28.95-8.75,0-.17-.09-.34-.12-.51a5,5,0,0,1,5.46-5.68,24.74,24.74,0,0,0,6.07-.34,57.07,57.07,0,0,1,23.05,1.23A4.61,4.61,0,0,1,326.2,423.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.51,419.2a1.2,1.2,0,0,0,.74-.88.69.69,0,0,0-.16-.69c-.77-.8-3.9-.23-4.25-.16a.19.19,0,0,0-.17.15.21.21,0,0,0,.08.21,11,11,0,0,0,2,1.16A2.6,2.6,0,0,0,172.51,419.2Zm.28-1.29a.31.31,0,0,1,.06.31.78.78,0,0,1-.48.59c-.57.21-1.66-.18-3-1C170.67,417.59,172.38,417.48,172.79,417.91Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,417.87c1-.12,3.16-1.25,3.35-2.23a.7.7,0,0,0-.42-.79,1.12,1.12,0,0,0-.93-.07c-1.2.41-2.18,2.71-2.22,2.81a.24.24,0,0,0,0,.2.22.22,0,0,0,.09.07Zm2.72-2.66c.24.13.25.26.23.35-.12.6-1.59,1.53-2.62,1.82.37-.75,1.09-2,1.81-2.22a.66.66,0,0,1,.5,0Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.41 413.84 167.55 417.13 174.66 398.32 166.51 395.03 159.41 413.84",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.58,416.46l-9.14-3.69a.7.7,0,0,0-.88.28l-4,6.7a1.38,1.38,0,0,0,.71,1.95c3.22,1.24,4.83,1.67,8.85,3.3,2.48,1,6,2.71,9.4,4.1s5-1.87,3.69-2.75c-5.81-3.93-6-6.2-7.45-8.84A2.32,2.32,0,0,0,168.58,416.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.55 407.55 160.41 401.83 161.71 396.65 176.88 402.2 174.55 407.55",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.71,189.83c-2.87,8.31-11.36,27.87-17.91,19.72a19.19,19.19,0,0,1-2.86-4.76c-2.77-6.85-3.46-17.95-3.81-20.38l-2.23-7.61a1.39,1.39,0,0,1-.06-.4l0-4.35c0-1.76,1.42-2.81,3.34-2.65,0,0,3.1-.36,3.1,1.49l.6,6.53h0c.31,2.27-.59,5.43-.06,7.51,2,7.83,4.75,8.19,6.48,16.27,2.41-5.83,6.72-15.92,6.72-15.92C184.88,185.64,189.65,187.1,188.71,189.83Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45,212.53a5.15,5.15,0,0,1-8.47.29,18.87,18.87,0,0,1-2.76-5.19c-2.6-8.53-4.21-13.81-4.43-22.72A7,7,0,0,1,170,183.2l4.26,14.43s8.67-21.55,12.18-22.32c4.13-.91,5.85,2.78,7.6,7.32C195.3,185.89,184.1,203.82,178.45,212.53Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.48,153.74c-1,5-3.18,15.92.32,19.26,0,0-1.37,5.07-10.66,5.07-10.23,0-4.89-5.07-4.89-5.07,5.58-1.33,5.43-5.47,4.46-9.36Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.85,142a.58.58,0,0,0,.18,0,.41.41,0,0,0,.17-.54,3.92,3.92,0,0,0-2.89-2.21.39.39,0,0,0-.44.35.39.39,0,0,0,.35.44h0a3.17,3.17,0,0,1,2.27,1.78A.4.4,0,0,0,197.85,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,146.32a18.08,18.08,0,0,1-2.94,4,2.94,2.94,0,0,0,2.35.75Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.6,144.86c.15.66-.09,1.28-.52,1.37s-.91-.37-1.05-1,.09-1.28.53-1.38S195.46,144.19,195.6,144.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.76,143.82l-1.7-.12S194.15,144.77,194.76,143.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,169.05v0Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,185.57c1.77-1.63,3-1.14,3.78.15.81,3.74-4,11.58-5.89,14.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.3,190.5c-.23,4.12-.62,9.31-1.25,15.84-.66,6.89-1.6,15.26-2.89,25.43-13.59,0-27.82-.21-34.43-.21.56-13.51.76-27.2-5.3-54.08a2.55,2.55,0,0,1,2-3.07A97.27,97.27,0,0,1,199.38,173a108.94,108.94,0,0,1,15.55,0c6.67.61,14.25,2.16,14.25,2.16S230,177.64,229.3,190.5Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.3,190.5c-.23,4.12-.62,9.31-1.25,15.84-3.66-4.24-7.12-18.84-6-23.83a32.8,32.8,0,0,1,7.11,7.2A7.33,7.33,0,0,1,229.3,190.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.59,208.8l7-3.92,1.3,7.13s-5.9,2.27-9,.68Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.22,205.69l.49,2.33a1.86,1.86,0,0,1-.77,1.9L272.86,212l-1.3-7.13,2.41-.6A1.84,1.84,0,0,1,276.22,205.69Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.6,183.42c2.23,4.54,10.41,21.69,14,25.65l.71.74.35.37c.12.12.22.23.41.4a12.11,12.11,0,0,0,2.12,1.61,16.83,16.83,0,0,0,4.36,1.76,30.73,30.73,0,0,0,8.18.77,60,60,0,0,0,15.1-2.56L267,208c-2.31.2-4.73.34-7.07.38a56.93,56.93,0,0,1-6.95-.22,26.56,26.56,0,0,1-6.3-1.23,9.13,9.13,0,0,1-2.32-1.17,4.57,4.57,0,0,1-.75-.66,2.56,2.56,0,0,1-.22-.26l-.26-.31-.53-.62c-2.76-3.46-10.05-20.14-12.24-24.31Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.48,215.9a24.67,24.67,0,0,1-18.75,1.82,25.08,25.08,0,0,1-14.09-11.42c-3.61-5.31-13.22-20.33-12-24.21,1.43-4.64,4.47-7.52,9.55-6.27,3.57.86,10.38,18.2,13.68,25.13,1.29,1.93,3.77,5,6.54,5.94,4.89,1.69,8.49,1,13.61.23.94.56.87,1.43,1.34,2.4A7.26,7.26,0,0,1,264.48,215.9Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.52,145.73c-1.53,8.22-2,11.73-6.72,15.47-7.08,5.62-16.85,1.94-17.8-6.58-.86-7.67,1.79-19.83,10.31-22.12A11.41,11.41,0,0,1,218.52,145.73Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.7,191.24c-1.57,1.79-2.06,2.83-4.25,3.8s-6.93.12-8.44-1.73c.49,1.44,3.35,4,4.85,4.23a8.49,8.49,0,0,1-10.46-1.84,5.41,5.41,0,0,0,3.56,3.91c-19.16.5-11.09-8.52-23.09-21.35-13.28-14.2-10.4-25.94-10.4-25.94a13.54,13.54,0,0,0-2.61-8.14c-1.92-2.46-1.36-5.78-.75-7.64.89-2.73,3.6-3.69,6.2-3.85.46-2.69,6-2.2,6.67-1.75s.75.36,1.36,0c1.35-.87,4.75-1.77,8.39,1.17,2.22,1.8,4.6,5,4.68,11.88.08,7.13-3.33,15.6,8.47,26.43C238.83,176.78,235.5,190.49,247.7,191.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.89,146.35a6.28,6.28,0,0,0-1.08,4.54c.34,2.11,2.39,2.25,3.88.9s2.79-3.79,1.69-5.54S199.05,144.75,197.89,146.35Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.45,231.76s-4.09,57.41-8.69,95.27a93.2,93.2,0,0,1-10.22,32.48L175,402.07l-11.56-4.55s8-40.45,23.59-62.51c0,0-11.66-65.93,3.6-103.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.73,245.67s3.44,26,5.32,41.47C199,277.84,193.53,264.86,200.73,245.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.64,424.59a1.15,1.15,0,0,0,.24-1.12.69.69,0,0,0-.47-.53c-1.07-.36-3.56,1.59-3.84,1.81a.22.22,0,0,0-.07.22.21.21,0,0,0,.17.14,10.46,10.46,0,0,0,2.35.09A2.57,2.57,0,0,0,245.64,424.59Zm-.37-1.26a.28.28,0,0,1,.2.24.75.75,0,0,1-.14.74c-.4.45-1.54.61-3.1.45C243.25,424,244.71,423.13,245.27,423.33Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.82,425.08c.79-.55,2.2-2.56,1.9-3.51a.72.72,0,0,0-.75-.51,1.11,1.11,0,0,0-.85.36c-.87.92-.64,3.4-.63,3.51a.24.24,0,0,0,.12.17.22.22,0,0,0,.11,0A.17.17,0,0,0,241.82,425.08Zm1.14-3.61c.27,0,.34.12.37.21.17.59-.68,2.08-1.45,2.81a4.64,4.64,0,0,1,.54-2.79.67.67,0,0,1,.44-.22Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.52 425.89 240.28 425.05 237.6 405.15 228.84 406 231.52 425.89",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.87,424l-9.84.95a.69.69,0,0,0-.64.66l-.36,7.77a1.4,1.4,0,0,0,1.56,1.39c3.42-.38,5-.74,9.38-1.16,2.66-.26,6.58-.36,10.26-.71s3.51-3.95,2-4.13c-7-.79-8.29-2.69-10.79-4.38A2.39,2.39,0,0,0,240.87,424Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.11,231.75s11.21,68.51,13.36,109.09l.41,72.7-9.07,1.77s-13.13-46.38-14.65-73.19c-4-71.12-27.17-71.24-13.23-110.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.89 413.84 226.88 415.89 225.35 410.13 241.4 408.04 241.89 413.84",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,169.12h0v-.05S160,169.1,160,169.12Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,158.25h.57a1,1,0,0,0-1,1.05l.92,17.41a1.11,1.11,0,0,0,1.1,1H162a1.12,1.12,0,0,1-1.1-1L160,159.3A1,1,0,0,1,161,158.25Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,158.25h.57a1,1,0,0,0-1,1.05l.92,17.41a1.11,1.11,0,0,0,1.1,1H162a1.12,1.12,0,0,1-1.1-1L160,159.3A1,1,0,0,1,161,158.25Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.15,177.76h7a1,1,0,0,0,1-1l-.91-17.41a1.12,1.12,0,0,0-1.1-1.05h-7a1,1,0,0,0-1,1.05l.91,17.41A1.12,1.12,0,0,0,162.15,177.76Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.15,177.76h7a1,1,0,0,0,1-1l-.91-17.41a1.12,1.12,0,0,0-1.1-1.05h-7a1,1,0,0,0-1,1.05l.91,17.41A1.12,1.12,0,0,0,162.15,177.76Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.73,176.35a.65.65,0,0,1-.17.48.67.67,0,0,1-.47.19h-6.81a.75.75,0,0,1-.74-.71l-.89-16.89a.61.61,0,0,1,.17-.47.63.63,0,0,1,.47-.2h6.81a.75.75,0,0,1,.74.71l.06,1.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.9,160.67,166.64,177h-2.71l2.56-18.27h1.61a.75.75,0,0,1,.74.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.95 177.02 162.34 177.02 164.9 158.75 165.51 158.75 162.95 177.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.52,233.7a74,74,0,0,0-8,32.35c17,13.19,32.83-2.26,52.29.35-.68-8.79-3.67-25-7.21-33.12C212.71,233.83,200.67,232.54,188.52,233.7Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.29,230.13s-1.37,3.53-1,3.53H225c.31,0,.56-.15.58-.35l.31-3c0-.21-.25-.39-.58-.39H190.85A.63.63,0,0,0,190.29,230.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.32,234h-.92c-.19,0-.33-.1-.32-.22l.44-4c0-.12.17-.21.35-.21h.93c.18,0,.32.09.31.21l-.43,4A.35.35,0,0,1,195.32,234Z",
    style: {
      fill: "#FCB040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.68,234h-.92c-.18,0-.32-.1-.31-.22l.43-4c0-.12.17-.21.36-.21h.92c.18,0,.32.09.31.21l-.43,4C218,233.86,217.87,234,217.68,234Z",
    style: {
      fill: "#FCB040"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoFactorAuthenticationRafiki);
export default __webpack_public_path__ + "static/media/Two-factor-authentication-rafiki.7335ed736df0936cf9a30e20702d1a5e.svg";
export { ForwardRef as ReactComponent };